import { render, staticRenderFns } from "./BizDetailPopup.vue?vue&type=template&id=627b003e&"
import script from "./BizDetailPopup.vue?vue&type=script&lang=js&"
export * from "./BizDetailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports